module.exports = __webpack_public_path__ + "static/media/16.2d21ac27.jpg";